type ExitSlipResponseLike =
  | {
      readonly score: number | null | undefined;
      readonly maxScore: number | null | undefined;
      readonly attempted?: boolean | null | undefined;
      readonly itemReference?: string | null | undefined;
    }
  | null
  | undefined;

export interface ExitSlipItemScore {
  key: string;
  score: number;
  maxScore: number;
  attempted: boolean;
}

export const groupExitSlipResponsesByItem = (
  responses: ReadonlyArray<ExitSlipResponseLike> | null | undefined,
): ExitSlipItemScore[] => {
  const byItem = new Map<string, ExitSlipItemScore>();
  (responses ?? []).forEach((response, index) => {
    if (!response) return;
    const key = response.itemReference ?? `response-${index}`;
    const item = byItem.get(key) ?? { key, score: 0, maxScore: 0, attempted: false };
    item.score += response.score ?? 0;
    item.maxScore += response.maxScore ?? 0;
    item.attempted = item.attempted || !!response.attempted;
    byItem.set(key, item);
  });
  return [...byItem.values()];
};
